import {ACTION_CODE} from './_actionCode';
import {FileService} from '../../services';
import {ErrorModel, ResultModel} from '../../models';
import {LoggerService} from '../../services';
const FUNCTION_CODE = 'CREATE_FILE';

export async function createFile(userData: Record<string, any>, payload: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - createFile - Start');

        const createFileResult = await FileService.createFile(userData, payload);

        LoggerService.logInfo('Action - createFile - End - Success');

        return ResultModel.newSuccessResult(createFileResult);
    }
    catch (error) {
        LoggerService.logInfo('Action - createFile - End - Error');

        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
